export const formatTrailerSRLabel = ({ active, model, tireFrontSize, tireRearSize }) => {
  const baseString = tireRearSize ?
    `${model} front: ${tireFrontSize} rear: ${tireRearSize}` :
    `${model} ${tireFrontSize}`

  return !active ? `select ${baseString}` : `${baseString} is selected vehicle`
}
